import React from 'react';
import styles from './styles';
import {StagingImage} from '@xpertdox_js/xdcomponents';
import {absCenter} from '@xpertdox_js/xdstyle';
import axiosConfig from '../../../../config/axios.config';

const Assets = props => {
  return(
    <div style={styles.assetsContainer}>
      {props.assets.map((asset, i) => {
        return(
          <StagingImage
            axiosConfig={axiosConfig}
            key={asset._id}
            imageDisplay={{
              filename: asset.filename,
              id: asset._id,
              styles: {
                container: {
                  ...absCenter,
                },
                image: {
                  width: '95%',
                  display: 'block',
                  margin: '0 auto'
                }
              }
            }}
            styles={{
              container: {
                width: '100px',
                height: '100px',
              },
              button: {
                width: '24px',
                top: '5px',
                right: '5px',
                height: '24px',
              },
              svg: {
                width: '18px',
                height: '18px'
              }
            }}
            callback={asset => props.removeAsset(asset)}
          />
        )
      })}
    </div>
  )
}

export default Assets;
